<div
  *transloco="let t; read: 'calculator_result.result.values.yearly-payment'"
  class="flex flex-col">
<div  *ngIf="canGetLoan">
  <psc-section-title
    class="mb-4"
    [title]="t('title')"
    alignment="left"
    [size]="smallTitle ? 'small' : 'normal'"
    [lineWidthPercentage]="100"
    [lineThickness]="2">
  </psc-section-title>

  <div class="w-full md:w-3/5 lg:w-3/5 overflow-x-auto mx-auto mt-5">
    <table class="w-full border-collapse text-center shadow-lg">
      <thead>
      <tr>
        <th class="p-3  w-auto"></th>
        <th class="p-3 bg-blue3 text-white"  [ngClass]="{'w-1/2': !canGetLoan, 'w-1/3': canGetLoan}">{{ t('realSpending') }}</th>
        <th class="p-3 bg-blue2 text-white"  [ngClass]="{'w-1/2': !canGetLoan, 'w-1/3': canGetLoan}">{{ t('spendingWithSolar') }}</th>
        <th class="p-3 bg-green1 text-white w-1/3">{{ t('spendingWithBanks') }}</th>
      </tr>
      </thead>

      <tbody>
      <tr *ngFor="let item of solarCalculatorResult | slice:0:12; let i = index"
          class="even:bg-gray-100 odd:bg-white">
        <td class="p-3 bg-white">{{ currentYear + i }}</td>
        <td class="p-3 bg-blue3 bg-opacity-20">{{ item.realSpending | number:'1.2-2' }} {{ currency }}</td>
        <td class="p-3 bg-blue2 bg-opacity-20">{{ item.spendingWithSolar | number:'1.2-2' }} {{ currency }}</td>
        <td class="p-3 bg-green1 bg-opacity-20">{{ item.spendingWithBanks | number:'1.2-2' }} {{ currency }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
</div>
